var map = {
	"./frame-team-tablet.png": "e27d",
	"./frame-team.png": "3577",
	"./frame-winner-tablet.png": "0b79",
	"./frame-winner.png": "9b1b",
	"./green/atobe112.png": "acde",
	"./green/bajheera.png": "9c11",
	"./green/logo-frame-tablet.png": "c68f",
	"./green/logo-frame.png": "4e66",
	"./green/logo-tablet.png": "b2f7",
	"./green/logo.png": "03f3",
	"./green/zizaran.png": "6895",
	"./orange/logo-frame-tablet.png": "0a82",
	"./orange/logo-frame.png": "b78e",
	"./orange/logo-tablet.png": "9a50",
	"./orange/logo.png": "a671",
	"./orange/mimi.png": "40a4",
	"./orange/savix.png": "3909",
	"./orange/stoopzz.png": "6524",
	"./pink/blaustoise.png": "21b8",
	"./pink/daboki.png": "52d8",
	"./pink/logo-frame-tablet.png": "c94a",
	"./pink/logo-frame.png": "7861",
	"./pink/logo-tablet.png": "1d15",
	"./pink/logo.png": "b986",
	"./pink/peterpark.png": "a1fd",
	"./thunder-team-left-tablet.png": "4b9c",
	"./thunder-team-left.png": "ae57",
	"./thunder-team-right-tablet.png": "afd2",
	"./thunder-team-right.png": "b315",
	"./thunder-winner-left-tablet.png": "9d4a",
	"./thunder-winner-left.png": "ecfb",
	"./thunder-winner-right-tablet.png": "e89d",
	"./thunder-winner-right.png": "4be3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5cc2";